import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CloseCaption"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.302 21.75L12 21L15 15.75H19.5C19.898 15.7506 20.2799 15.5928 20.5613 15.3113C20.8428 15.0299 21.0006 14.648 21 14.25V5.25C21.0006 4.85199 20.8428 4.47011 20.5613 4.18868C20.2799 3.90725 19.898 3.7494 19.5 3.75H4.5C4.10199 3.7494 3.72011 3.90725 3.43868 4.18868C3.15724 4.47011 2.9994 4.85199 3 5.25V14.25C2.9994 14.648 3.15724 15.0299 3.43868 15.3113C3.72011 15.5928 4.10199 15.7506 4.5 15.75H11.25V17.25H4.5C2.84315 17.25 1.5 15.9069 1.5 14.25V5.25C1.4998 4.45429 1.81581 3.69111 2.37846 3.12846C2.94111 2.56581 3.70429 2.2498 4.5 2.25H19.5C20.2957 2.2498 21.0589 2.56581 21.6215 3.12846C22.1842 3.69111 22.5002 4.45429 22.5 5.25V14.25C22.5 15.9069 21.1569 17.25 19.5 17.25H15.8738L13.302 21.75ZM14.25 14.25V12.75H18.75V14.25H14.25ZM12.75 12.75H8.25V14.25H12.75V12.75ZM4.5 12.75H6.75V14.25H4.5V12.75ZM19.5 9.75H16.5V11.25H19.5V9.75ZM9.75 9.75H15V11.25H9.75V9.75ZM8.25 9.75H4.5V11.25H8.25V9.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CloseCaption.vue"]]);
